import React from 'react'
import Video from './Video'
import videoForestal from '@/videos/video-forestal.mp4'
import videoPoblaciones from '@/videos/video-poblaciones.mp4'

const Textos = ({ trimestre }) => {
  switch (trimestre) {
    case '2020-0':
      return (
        <>
          <p>
            Son distintos los sitios estratégicos utilizados por los
            narcotraficantes en el área central del país, los que usando sus
            redes y aprovechando las zonas con ausencia del Estado, han avanzado
            y han establecido distintos centros de operaciones en el Gran
            Santiago.
          </p>

          <p>
            ¿Qué tan profundo se ha extendido el fenómeno y cuáles son las áreas
            en que los traficantes se han enquistado en la capital? La Unidad de
            Investigación y Datos de La Tercera analizó las 730 causas por
            infracción a la Ley de Drogas tramitadas por la Corte de Apelaciones
            de San Miguel y la Corte de Apelaciones de Santiago en 2020 y el
            primer trimestre de 2021. Ambos tribunales concentran la totalidad
            de la jurisdicción de la Región Metropolitana.
          </p>

          <p>
            En este análisis realizado por La Tercera, se identificaron las
            zonas donde la venta de drogas ha mostrado una tendencia al alza e,
            incluso, ha incrementado su presencia, de acuerdo a los registros
            del Poder Judicial y la Fiscalía. Y si bien la muestra general
            revisó los casos que tuvieron su origen en enero de 2020 en las
            cortes de Apelaciones, en el registro existen indagatorias cuyas
            fechas de inicio datan de fechas anteriores, debido a que fueron
            tramitadas previamente por el Ministerio Público. Así, en el “punto
            cero” del mapa, ya aparecen 403 causas, arrastrando algunas
            investigaciones que tuvieron su origen en 2015.
          </p>
        </>
      )
      break

    case '2020-1':
      return (
        <>
          <p>
            Al estudiar cada uno de los casos, La Tercera pudo identificar todas
            las direcciones y puntos específicos en que la policía detectó
            actividad relacionada al narcotráfico. Así, comenzaron a aparecer
            desde esquinas en que operan microtraficantes hasta verdaderos
            centros de operaciones, desde los cuales se coordinan acciones que
            incluyen la internación de drogas “duras” desde el extranjero.
          </p>
          <Video
            src={videoPoblaciones}
            url="https://www.latercera.com/investigacion-y-datos/noticia/mi-vecino-el-narco-zoom-a-los-900-centros-de-operaciones-en-la-rm/Q5YYXM3W7BG6PK4MMRVKAWVDSA/"
          />
          <p>
            Una de las primeras conclusiones que arroja el análisis, sustentado
            también en la opción de vecinos y expertos, es que existe un vínculo
            entre la ruptura del tejido social y el avance del narcotráfico y
            delincuencia. Hoy en la Región Metropolitana el gobierno trabaja con
            más de 500 dirigentes vecinales de 34 sectores, en 12 comunas, para
            aplicar el programa Barrios Prioritarios. Esta política pública
            surge de una necesidad alertada por los propios vecinos y policías:
            los nuevos focos de narcotráfico en las zonas de menores recursos.
          </p>
        </>
      )
      break

    case '2020-2':
      return (
        <>
          <p>
            Se detectaron 66 territorios de venta en vía pública, 695 casas que
            se ocupan como puntos de venta o de acopio de narcóticos, así como
            53 residencias que se utilizan como laboratorios o invernaderos. El
            levantamiento de información también reveló que existieron 167 zonas
            en que imputados fueron sorprendidos transportando o internando
            narcóticos.
          </p>

          <p>
            Esto arroja un total de 981 puntos dentro de la Región Metropolitana
            que han sido tomados por narcotraficantes para usarlos como
            trincheras para concretar sus negocios.
          </p>

          <p>
            No es todo. El levantamiento arrojó la existencia de 34 casos en que
            el tráfico tuvo como escenario alguna de las cárceles de Santiago o
            Colina. Gran parte de estas causas fueron intentos de internación de
            droga, la que luego sería vendida al interior de los recintos
            penitenciarios.
          </p>

          <p>
            Con la información recopilada, se asignó la coordenada GPS a las 981
            direcciones detectadas y así lo logró crear un mapa que revelara el
            avance del narco en la Región Metropolitana. El estudio reveló que,
            si bien el fenómeno se encuentra extendido a prácticamente toda la
            ciudad, existen 16 zonas críticas en que el traficante ha logrado
            imponerse.
          </p>
        </>
      )
      break
    case '2020-3':
      return (
        <>
          <p>
            Entre las zonas que registran el mayor número de causas e
            incautaciones vinculadas al narcotráfico, se encuentra el cuadrante
            conformado por la Ruta 5 Sur, Autopista General Velásquez, Autopista
            Vespucio Sur y la Autopista del Sol. Se trata de un área compartida
            por las comunas Pedro Aguirre Cerda y Lo Espejo.{' '}
          </p>

          <p>
            Otra zona caliente se encuentra en General Velásquez con la Alameda,
            cerca de los terminales de buses en Estación Central. La mayor parte
            de estas corresponden a detenidos que fueron sorprendidos tomando
            locomoción en dirección al sur y que tendrían escondido algún tipo
            de narcótico entre sus pertenencias.
          </p>

          <p>
            El mapeo, además, evidencia otra realidad: la existencia de clúster
            que atraviesan más de una población o villa, así como otros que se
            encuentran radicados en un sector en específico. De esta manera, a
            modo de ejemplo, el registro arroja la existencia de una zona
            caliente que incluye la Villa El Almendral, Villa La Juanita y Bajos
            de Mena, en Puente Alto. Los límites están dados por la Autopista
            Vespucio Sur y Santa Rosa.
          </p>

          <p>
            Y cuando se trata de problemas focalizados, la problemática se
            manifiesta con mayor fuerza en las poblaciones La Legua de San
            Joaquín, Carol Urzúa de Puente Alto, La Pincoya de Huechuraba, Valle
            de la Luna de Quilicura y San Gregorio de La Granja.
          </p>

          <p>
            Respecto a los laboratorios y lugares de plantación de marihuana, el
            levantamiento de información arroja que esta ocurre con mayor
            frecuencia en la zona rural de la Región Metropolitana.
          </p>
        </>
      )
      break

    case '2020-4':
      return (
        <>
          <p>
            En la población Carol Urzúa de Puente Alto aparece uno de los
            clúster de narcotráfico. Un hombre mayor acepta conversar unos
            minutos con La Tercera, con la condición de mantener su anonimato.
            En esta zona, estar alejados de polémicas es un asunto de
            supervivencia. “De que han pasado cosas en la población, sí, todo el
            mundo lo sabe. Tuvimos a una cuadra de acá los cinco muertos en las
            máquinas de juegos, y fue por la droga”, relata.
          </p>

          <p>
            La presencia del narcotráfico se siente, especialmente, durante las
            noches. “Los fuegos artificiales son casi todas las semanas. De
            23.00 a 1.00 de la mañana. Y ninguna policía viene. Han bajado los
            disparos, eso sí. Como que los fuegos artificiales ocuparon ese
            lugar”, cuenta el vecino.
          </p>

          <p>
            Pero no fue siempre así. “Aquí se terminó el club de fútbol que
            teníamos y se terminó todo el contacto que había entre las personas.
            Era el Deportivo Carol Urzúa, teníamos buenos jugadores y buenos
            infantiles. Pero por problemas que había con otros sectores, como La
            Esperanza, se terminó el fútbol y aumentó fuerte la droga”, indica
            el vecino.
          </p>

          <p>
            La esquina de Elqui con Coyhaique, en Puente Alto, es otra zona
            rodeada por puntos de venta. Ahí, un hombre de la tercera edad
            relata que “llevo viviendo acá desde el año 1986, pero la cosa se ha
            ido poniendo peor”.
          </p>

          <p>
            Respecto a la existencia de alguna organización vecinal, señala que
            “acá no tenemos ni delegados. Cada uno vive su mundo y lo mejor es
            ni meterse, porque te los echarás encima. Hay una comisaría acá
            cerca, pero igual no respetan y hacen sus cosas”.
          </p>

          <p>
            El mapa, además, arroja otra realidad: cada vez que una “casa-narco”
            es allanada y neutralizada, es común que otra residencia en el mismo
            sector ocupe el lugar que quedó vacante.
          </p>
        </>
      )
      break

    case '2021-1':
      return (
        <>
          <p>
            Luis Eduardo Bresciani, director de la Escuela de Arquitectura de la
            Universidad Católica, explica los factores aprovechados por la
            delincuencia organizada: “Una de las condiciones que ha favorecido
            la aparición del narcotráfico es justamente algo que se percibe en
            estos barrios: cierto grado de homogeneidad, segregación social,
            falta de diversidad social, es un barrio que se caracteriza por
            viviendas construidas por el Estado hace muchas décadas”.
          </p>
          <Video
            src={videoForestal}
            url="https://www.latercera.com/investigacion-y-datos/noticia/mi-vecino-el-narco-zoom-a-los-900-centros-de-operaciones-en-la-rm/Q5YYXM3W7BG6PK4MMRVKAWVDSA/"
          />
          <p>
            De acuerdo a Bresciani, otro elemento es la poca cohesión social y
            cuando se rompen las redes entre los vecinos. En el fondo, cada uno
            se preocupa de su metro cuadrado y desaparecen los espacios de
            convivencia.
          </p>

          <p>
            La situación, no obstante, tiene una salida, en la cual los
            gobernadores pueden jugar un rol central. “El tema de la ciudad es
            esencialmente territorial. Y ahí las autoridades que gobiernan
            territorios son fundamentales para unir la construcción de
            infraestructura, generar equidad en la inversión pública, mejorar
            viviendas y planificar”, señala Bresciani.
          </p>

          <p>
            Desde la Subsecretaría de Prevención del Delito, en tanto, indican
            que la institución trabaja en un programa de 34 barrios prioritarios
            y en el caso de la RM, estos se encuentran en 12 comunas. Añadieron
            que en esta iniciativa “los vecinos son actores esenciales” y que es
            “la propia comunidad, los vecinos y dirigentes, los que definen qué
            obra se realizará en su barrio, enfocadas siempre a dar más
            seguridad, más tranquilidad y mejorar la calidad de vida de estos
            territorios”.
          </p>
        </>
      )
      break
    case 'final':
      return (
        <>
          <p>
            Para urbanistas y expertos en seguridad, una de las maneras más
            efectivas para recuperar los espacios tomados por el narco es crear
            redes entre los vecinos e incrementar la comunicación con las
            autoridades. Este es el camino que han tomado los residentes de los
            sectores Bellas Artes y Parque Forestal, en el centro de Santiago.
            Ambos sitios, revela el mapa, registran detenciones ligadas al
            tráfico de drogas.
          </p>

          <p>
            Francisco Javier González, presidente de la Junta de Vecinos de
            Bellas Artes, cuenta que “tenemos una comisión exclusiva para ver el
            tema de la seguridad, con vecinos que conocen el tema y han
            trabajado en la prevención del delito. Tratamos de buscar soluciones
            amigables, no a la violencia de ninguna índole, pero sí al diálogo”.
          </p>

          <p>
            “Hay vecinos que residen y venden sustancias. Eso es una
            problemática. Tratamos de hacer las denuncias de buena forma para
            que el edificio completo tenga bienestar. Acá no hay casas, son solo
            edificios”, cuenta.
          </p>

          <p>
            A pocas cuadras se encuentra la Junta de Vecinos del Parque
            Forestal. Héctor Vergara, el presidente, explica que “tenemos una
            buena coordinación con Carabineros, PDI, y ahora con seguridad
            municipal, para tratar de mantener a raya el problema. Sin lugar a
            dudas no se soluciona del día a la noche”.
          </p>

          <p>
            Respecto al narcotráfico, Vergara identifica dos problemas: primero,
            la normalización, en que se ve a consumidores y traficantes en plena
            calle, y segundo es “la cercanía de Bellavista, que es una zona de
            carrete más pesado al nuestro. Es un pasillo en nuestro barrio y eso
            nos afecta”.
          </p>
        </>
      )
      break

    default:
      return 'nope'
      break
  }
}

export default Textos
